import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { TRANSLATION_KA } from "./translations/ka";
import { TRANSLATION_EN } from "./translations/en";

const languageLoader = () => {
  const pathname = window.location.pathname;

  const segments = pathname.split("/").filter((segment) => segment !== "");

  for (const segment of segments) {
    if (segment === "en" || segment === "ka") {
      return segment;
    }

    if (segment.startsWith("en") || segment.startsWith("ka")) {
      return segment.substring(0, 2);
    }
  }

  const storedLanguage = localStorage.getItem("culture");
  if (storedLanguage === "en" || storedLanguage === "ka") {
    return storedLanguage;
  }

  return "ka";
};

const resources = {
  en: {
    translation: {
      videoIdentity: "video identity",
      username: "Name",
      online: "online",
      languageGe: "GE",
      languageEn: "ENG",
      title: "title",
      confirmation: "Confirm",
      documentNumber: "Document Number",
      Cancel: "Cancel",
      confirmationText:
        "An account can be opened by a private individual with an identity card, passport of a citizen of Georgia or with a permanent residence card",
      step2ConfirmText:
        "You have successfully completed the video identification",
      name: "Name",
      lastName: "LastName",
      age: "Age",
      birthDay: "Date of Birth",
      citizenship: "Citizenship",
      idNumber: "Personal Number",
      city: "City",
      city_name: "City Name",
      country_code: "Please select country code",
      birth_city: "Birth City",
      village_name: "Village Name",
      country: "Country",
      village: "Village",
      street: "Street",
      homeNumber: "House No",
      sex: "Sex",
      PhoneNumber: "Mobile number",
      resident: "Resident",
      nonResident: "Non Resident",
      next: "Next",
      prev: "back",
      required: "Please, fill in the marked field",
      requiredSelect: "Please, tick the desired box.",
      requiredConfirm: "Please confirm.",
      typeAddress: "Type Address",
      address: "Address",
      email_address: "E-mail address",
      email: "E-mail",
      validEmail: "Enter valid email address",
      yes: "Yes",
      no: "No",
      birthCountry: "Birth Country",
      cityzenShipCountry: "Select country",
      agreementText:
        "JSC ProCredit Bank is authorized to process my personal data, including photo/video material obtained during the identification process and biometric data (facial features), to review the application and provide banking services as established by law and to the extent necessary to achieve the goal; also, make the above data available for identification to a third-party software provider (Identomat Inc). I also give consent to JSC ProCredit Bank to receive and process my personal data maintained with the database of the LEPL Public Services Development Agency.",
      agreementText2:
        "I acknowledge that biometric data processing is essential for reliable identification. I am aware that the Bank maintains and processes data on a secure server. Besides, data are transmitted only through secure means of communication. The Bank ensures the protection of information from accidental or unlawful destruction, alteration, disclosure, extraction, any other form of misuse and accidental or unlawful loss.",
      agreementText3:
        "I am aware of the rights under the law that the data controller, upon request, is obliged to correct, update, add, block, delete or destroy data if they are incomplete, inaccurate, not updated or if they have been collected and processed against the law.",
      agreementText4:
        "I do hereby confirm that I have read, agree to and undertake to adhere to documents of the ",
      agreementLinkText1: "“Banking Service Conditions“",
      and: " and the ",
      agreementLinkText2: "Service Tariffs",
      agreement4Last:
        ", posted on the website of JSC ProCredit Bank at www.procreditbank.ge. I have stored and/or printed out the documents so that I have access to information about banking products.",
      agreementText5:
        "I agree to use the signature provided in the ID document (specimen signature) in the relationship with the Bank",
      agreementText6:
        "I understand that filling out this form does not mean opening an account and services with ProCredit Bank in a mandatory manner.",
      agreementText7:
        "I understand that the account(s)/service(s) will be closed automatically unless the agreements are confirmed through Internet Bank within two weeks after the registration of the account(s)/service(s) under the conditions applicable at the Bank.",
      confirmationStep1: "Consents",
      identificationStep2: "Identification",
      identityInformation3: "About You",
      identityInformationUpdate3: "Update data",
      identityInformation4: " Personal Information",
      identityInformation5: " About Services",
      identityInformation6: "Confirmation",
      cityVillage: "City/Village",
      notValidEmail: "Not Valid Email",
      notValidPhone: "Enter valid mobile number",
      chooseCountry: "choose country",
      brithCountry: "Birth Country",
      errorText: "Your identification failed, please try again.",
      isActualAddress:
        "Please, fill in if your legal address is different from the actual address",
      isActualEmailAddress:
        "Fill in mailing address if it is different from residential address",
      actualCityVillage: "Actual address",
      haveDualCitizenShip: "Are you a citizen of two countries?",
      haveAnotherCountryResidence:
        "Are you a resident of any country other than Georgia?",

      currentResidenceCountry: "Current residence country",
      currentResidenceCity: "Current residence city",
      currentResidenceAddress: "Current residence address",
      currentResidencePostalCode: "Current residence postal code",

      countryOfTaxResidence: "Country of Tax Residence",
      ifHaveLocaTaxIdentificationNumber:
        "Do you have Local Tax Identification Number (TIN)?",
      locaTaxIdentificationNumber: "Local Tax Identification Number (TIN)",
      tinType: "TIN Type",
      explainUnableTinReason:
        "Please explain why you are unable to obtain a TIN",

      tinIsNotAvailable: "If no TIN available enter Reason",
      notIssuingTin:
        "The country where the Account Holder is liable to pay tax does not issue TINs to its residents",
      otherwiseUnable:
        "The Account Holder is otherwise unable to obtain a TIN or equivalent number.",
      disclosureOfTINIsNotRequired:
        "Disclosure of TIN is not required by the tax authority of the respective country.",

      step3AcceptanceText1:
        'The need to process the data in the form is derived from the Order of the Minister of Finance of Georgia No. 125 "On Administrative Cooperation in Tax Matters" within the framework of the Convention of January 25, 1988 "On the Automatic Exchange of Information on Financial Account Information in Tax matters" by the Multilateral Model Competent Authority Agreement (CRS MCAA) or between Georgia and the relevant jurisdiction in order to fulfill the duties assigned to the bank in accordance with the reporting procedure provided for in the agreement on the automatic exchange of information on financial accounts.',
      step3AcceptanceText2:
        "I acknowledge that the information contained in this form and information regarding the Account Holder and any Reportable Account(s) may be provided to the tax authorities of the country in which this account(s) is/are maintained and exchanged with tax authorities of another country or countries in which the Account Holder may be tax resident pursuant to intergovernmental agreements to exchange financial account information.",
      step3AcceptanceText3:
        "I declare that all statements made in this Certification are correct. I undertake to advise ProCredit Bank promptly of any change in circumstances which causes the information contained herein to become incorrect and to provide ProCredit Bank with a suitably updated Certification within 30 days of such change in circumstances.",

      indicateDualCitizenshipCountry:
        "Please indicate the country of second citizenship",
      genderMale: "Male",
      genderFeMale: "Female",
      male: "მამრობითი/Male",
      fillLegalAddress: "Please, enter your legal address",
      legalAddressFilled: "Legal address",
      fillFizicalAddress: "Please, enter your actual address",
      fatca:
        "Are you a US-related person financially or in any other form (residential address, telephone number) or a taxable entity under FATCA?",
      green_card: "Are you a Green Card holder?",
      federal_tax:
        "Check the appropriate box for the Federal Tax Classification:",
      federal_tax_classification: "Federal Tax Classification",
      comment: "Comment",
      write_comment: "Write comment",
      address_placeholder: "Number, street, number of apartment or office",
      street_placeholder: "City, country and postal index",
      account_nums: "Account number(s)",
      account_nums_placeholder: "List account number(s)",
      TIN: "Taxpayer identification number (TIN)",
      federal_comment:
        "Tax classification (C=C corporation, S=S corporation, P=Partnership)",
      fatca_privacy:
        " In this document, I give my consent to process my personal data under FATCA regulations and objectives. (Required to check if the upper fields are filled.",
      account_services:
        "Information about the purpose and intended nature of the business relationship with the bank",
      fatcaPrivacy:
        " In this document, I give my consent to process my personal data under FATCA regulations and objectives. (Required to check if the upper fields are filled.",
      money_transfer_from: "Incoming from",
      money_transfer_to: "Outgoing to",
      pep: "Are you a politically exposed person (PEP), or are you related to PEPs?",
      select: "Select",
      select_1: "Select...",
      legal_form: "Legal form",
      activity_subject: "Activity subject",
      select_activity_subject: "Select activity subject",
      income_source: "Source of income ",
      employment_status: "Employment Status",

      write_income_source: "Select your source of income",
      monthly_turnovers: "Expected monthly turnover in GEL",
      workspace: "Workplace",
      workplace: "Workplace",
      position: "Position",
      monthly_income: "Monthly Income in GEL",
      write_monthly_income: "Select your monthly income in GEL",
      position: "Position",
      write_position: "Write your position",
      start_date: "Start date",
      turnovers_definition:
        "Turnover refers to the sum of debit and credit turnovers",
      TIN_definition:
        "Enter your taxpayer identification number (TIN) in the appropriate field. To avoid double income taxation at the source of payment,  the specified TIN must match the name in the 'Name'  field. For individuals, this is your social security number (SSN). For others,  this is your employer identification number (EIN) ",
      write_workspace: "Write your workspace",
      write_monthly_turnovers: "Select your monthly turnover in GEL",
      female: "მდედრობითი/Female",
      currentAccount: "Current account",
      currentyAccountDesc: "GEL, USD, EUR.",
      currentyAccountDescription: "GEL, USD, EUR.",
      seeRates: "Please see the rates.",
      GEL: "GEL",
      USD: "USD",
      EUR: "EUR",
      currentAccountSub:
        "The service tariff is determined by the number of accounts,",
      seeTariffs: "see Tariffs.",
      savingAccount: "Savings account",
      savingAccountDesc: "GEL, USD, EUR.",
      minimal: "Please, complete the registration process, activate the ",
      minimalAccount: "‘set Minimal’ ",
      getMinimal:
        "and benefit from complimentary services for the upcoming month.",
      standart:
        "Please, select one of the set the bank offers within a month. If no set is chosen, the ",
      standartAccount: "‘Standard Account’",
      forYou: "will automatically be applied.",
      smsService: "SMS service",
      smsServiceDesc: "You will receive notifications about transactions.",
      smsServiceDescription:
        "You will receive a message about the transactions on the account.",
      chooseLanguage: "Choose the language:",
      georgian: "Georgian",
      english: "English",
      internetBank: "Internet Bank",
      // chooseMeans:
      //   'Choose the means of receiving an Internet Bank username and password:',
      internetBankDescription:
        "A remote service channel, an up-to-date way to manage your bank accounts.",
      sourceForInternetBank:
        "Choose the source for receiving your Internet Bank username and password:",
      mobilePhoneNum: "Mobile phone number",
      both: "Both",
      fullVersion: "Full version",
      bankCard: "Bank card",
      // plasticCardDescStart: 'MasterCard debit card',
      // plasticCardDescEnd:
      //   'with which you can deposit/withdraw money, make online purchases and POS-terminal payments.',
      note: "Note!",
      cardNote:
        "After opening the account, the customer orders a plastic card from Internet Bank.",
      direct: "Direct",
      greenCard: "Green Card",
      greenCardTitle: "Green Card",
      greenCardOwner: "Are you a USA Green Card holder?",
      usaTaxPayerQuestion: "Are you a USA taxpayer?",
      chooseBaseAccount: "To select banking service, please, click on the card",
      enterValidDate: "Enter valid date",
      PEP_meaning: "Politically Exposed Person",
      pepCategory:
        "Do you or your family member belong to the category of politically exposed person? (Please see the definicion for PEP in annex)(In case of positive answer, please provide detailed information)",
      PEP_desc:
        " <bold>Politically Exposed  Person (PEP)</bold> – a natural person carrying out significant public or political activities (except for middle-and low-ranking officials), including the Head of the State; Head of the Government, member of the Government (Minister), his Deputy; senior official of a government institution; member of the legislative body (Parliament); head of a political union, member of the governing body; member of the Supreme Court or the Constitutional Court or another judicial body whose decisions are appealed in exceptional cases; Auditor General, his Deputy, member of the Court of Auditors; member of the Board of the National (Central) Bank; ambassador, head of diplomatic mission; senior official of Defense (Military) Forces; head of state-owned enterprise, member of a governing body; head of an international organization, deputy head being member of the governing body. Also, their family members belong to the category of Politically Exposed Persons: spouse/a person with whom a politically active person is permanently involved in a joint household, sister, brother, parent, child / stepchild and his / her spouse/a person with whom a person is permanently involved in a joint household.  <lb />  <lb /> Furthermore, the category of Politically Exposed Persons includes: a natural person who, together with a politically exposed person, is a beneficial owner of a legal entity, an unregistered organizational entity or a trust or a legal structure similar to a trust, or who otherwise has a close business, social or political relationship therewith; also, a natural person who is the beneficial owner of a legal entity, an unregistered organizational entity or a trust or a legal structure similar to a trust created de facto (informally) in favour of a politically exposed person.",
      FATCA_DESC:
        "FATCA - Foreign Account Tax Compliance Act - aims to increase the transparency of the US Tax Department in respect of persons staying under US jurisdiction, who may invest and receive revenue through accounts opened in non-American organizations. The FATCA provisions include measures to make foreign financial institutions provide the United States Revenue Service (IRS) with information about bank accounts of individuals staying under US jurisdiction. The individual must be treated as important under FATCA if one of the following is applicable: · Clients with a U.S. Residence permit or US citizenship · Clients having their address in the USA (whether a residential or correspondence address) · Clients who are born in the U.S. · Clients' contact number is the US telephone number · Clients whose trustees have US indicia · Clients who have instructions to transfer funds regularly to an account maintained in the U.S.",
      WHAT_IS_FATCA: "What is FATCA?",
      GREEN_CARD_TOOLTIP:
        "Green Card - an identification card that confirms the US residency but not citizenship. The holder has the right to permanently live and work in the United States of America.",
      otpTitle: "Are you sure you want to send TAN to number {{mobNUmber}}?",
      OtpWarning:
        "Please note that you should inform the bank immediately if you lose your mobile phone or change your mobile phone number!",
      OTPYes: "YES,PLEASE",
      OTPNo: "NO,THANK YOU",
      notValidCountry:
        "Unable to open an account with online identification. For opening the account, please visit",
      ourWebSite: "our Website",
      authenticationCode: "Authentication code",
      CodeWillSend:
        "Authentication code was  sent to the phone number {{number}}",
      finish: "Finish",
      sendSMS: "Send SMS",
      updateOTP: "Send again",
      finishText:
        "The identification and application filling process has been completed.",
      completedSuccessfully: "Completed successfully!",
      waitForMessage: "Wait for the bank to contact you.",
      branches: "To branch",
      ByPost: "By post",
      deliveryMethodLabel: "Delivery method",
      tbilisi: "Tbilisi",
      houseNumber: "House No",
      apartmentNumber: "Apartment No",
      selectBranch: "select Branch",
      MainCurrency: "Primary account",
      currency: "currency",
      AdditionalAccounts: " Additional account(s)",
      CardWillDelivered: "The card can be received by post in Tbilisi.",
      CardDeliveryTimes:
        "The card will be delivered to the address on working days from 10:00 to 18:00.",
      CardAccountSelectTitle: " - Select additional and primary accounts.",
      bankCardDesc: "You can order a card in Internet Bank",
      EstimatedCashFlow: "Estimated monthly cash turnover (GEL)",
      SourceOfCashFunds: "Source of income ",
      SourceOfCashFundsConfirmationText: "Source of funds/Income",
      sourceOfProperty: "Source of assets / wealth (except cash)",
      banksTitle: "Name of banks where you hold bank accounts;",
      banksConfirmationTitle: "Name of banks where you hold/held bank accounts",
      pleaseBeMoreSpecific: "please specify",
      pleaseSpecify: "Please specify",
      ConfirmInfoInQuestionnaire:
        "I do hereby confirm the accuracy of the information in the questionnaire",
      KycConfirmInfoInQuestionnaire:
        "I confirm the correctness of the information provided in the questionnaire",
      InformationOnCounterparties:
        "please indicate, e.g. the name, country, line of business. upon request, provide  mutually signed agreement(s) with the counterparties",
      InformationOnCounterpartiesPlaceholder: "Information on counterparties",
      date: "date",
      BirthPlace: "Birth place",
      dualCitizenship: "Dual citizenship",
      activityField: "The field of activity",
      montly_turnovers_title:
        "Total estimated monthly turnover on accounts (GEL)",
      // PEP_confirm_title:
      //   "Do you belong to the category of politically exposed person (PEP) *?",
      otherBank: "another bank",
      otherIncomes: "Other income",
      otherSourceOfProperty: "Other source of property origin",
      infoAboutDocumentationRequest:
        "(Upon request, provide relevant documents)",
      infoAboutSubmitDocumentationRequest:
        "(It is mandatory to submit relevant documentation according to annex due to the bank request)",
      knowYourClient: "Know Your Customer Questionnaire",
      CRSSelfDeclaration: "CRS Self-Certification for Individual Clients",
      applicationForm4: "Application form",
      PrivateIndividual: "Private individual",
      LegalEntity: "Legal entity",
      fullName: "Full name of the customer",
      personalNumber: "Personal number",
      NameOfCompany: "Name of the company",
      IdentificationNumber: "Identification number",
      DirectorFullName: "Full name of the director",
      PersonalNumberOfTheDirector: "Personal number of the director",
      TelephoneNumber: "Telephone number",
      PEPCreditInfo:
        "If you are a politically exposed person (PEP), please tick the YES box ",
      confirmationButton: "(YES box)",
      construction: "form under construction",
      mobileNumber: "Cell phone number:",
      EmailAddress: "E-mail:",
      actualAddress: "Actual address:",
      contactData: "Contact data:",
      contactDataChange: "Mark which data you want to change :",
      ChangeContactDataConfirmationText1:
        "I hereby confirm that the above information is correct. The Bank will record that information in its database and use it to communicate with you/the customer. All use of the service is subject to the ",
      ChangeContactDataConfirmationText2:
        ", which defines the content and all conditions of the service.",
      ServiceConditions: "Banking Service Conditions",
      identificationNumberInfo:
        "The number is taken from the identification process. If you want to change, identify yourself with the desired number.",
      identificationEmailInfo:
        "Email is taken from the identification process. If you want to change, identify yourself with the desired Email.",
      requiredConfirmation: "Please, confirm the above information",
      TickDesiredBox: "Please, tick the desired box",
      sms: "SMS",
      passwordSource:
        "Mark the source of receiving the one-time password of Internet Bank: ",
      authenticationPhoneNumber1: "Phone number",
      authenticationPhoneNumber2:
        "will be assigned to you for strong authentication and SMS code.",
      fillQuestionAndAnswer:
        "Fill in the internet bank code question and answer:",
      codeQuestion: "Code question",
      codeAnswer: "Code  answer",
      categoryOfPoliticalyExposedPerson:
        "Do you or your family member belong to the category of politically exposed person?",
      politicallyExposedPerson: "Politically exposed person (PEP)",
      familyMemberOfPoliticallyExposedPerson:
        " Family member of politically exposed person",
      relationshipWithAPoliticallyExposedPerson:
        "A person in a business relationship with a politically exposed person (owning/controlling shares of legal entities together with PEP or other close business relationship)",
      informationAboutRelatedPep:
        "Information about related PEP (Name, surname, position)",
      moreInfoAboutRelatedPep: "provide detailed information",
      informationRegardingAssets: "Information regarding assets",
      account_services_title_in_KYC_confirm:
        "Products/services you use/will use at Procredit Bank",
      IncomingFrom: "Incoming from:",
      OutgoingTo: "Outgoing to:",
      EstimatedCashFlows:
        "Turnover refers to the sum of cash debit and credit turnovers",
      turnoversDefinition:
        "Turnover refers to the sum of debit and credit turnovers",
      infoAboutSubmitRelevantDocumentationRequest:
        "(It is mandatory to submit relevant documentation due to the bank request)",
      Workplace_business_activity: "Workplace/business activity",
      dataUpdate: "Please choose what data you want to update/change",
      changePhoneSms: "Change a phone number for an SMS verification code",
      addPhoneSms: "Add a phone number for an SMS verification code",
      changeAuthenticationNumber: "Change the strong authentication number",
      addAuthenticationNumber: "Add the strong authentication number",
      changeAuthenticationMethod: "Change the strong authentication method",
      changeGenerationTool: "Change the generation tool",
      changeIbCode: "Change the Internet Bank code question-answer",
      changeIbEmailAddress: "Change the Internet Bank e-mail address",
      changeSourceIbPassword:
        "Change the source of getting the Internet Bank password",
      activateIb: "Activate Internet Bank",
      loginWithOneTimeCode:
        "Login with an additional one-time code confirmation.",
      deviceConfirmation: "A device for confirmation transactions.",
      usernameAndPassswordChannel:
        "Channel where Internet Bank username and password are sent",
      smsCode: "SMS Code",
      mobileToken: "Mobile Token",
      e_digipass: "E-Digipass",
      digipass: "Digipass",
      smsEmaill: "SMS/Email",
      kycBasicQuestions: "Basic questions",
      kycAdditionalQuestions: "Additional questions",
      dualCitizenship2: "Dual citizenship",
      dualCitizenshipCountry: "Country of second citizenship:",
      infoCounterparties: "Information on counterparties ",
      otherAssets: "Other assets (Including convertible virtual assets)",
      fieldsOfTheQuestionarieL:
        "Please fill all the fields of the questionarie",
      appropriateColumn:
        "It is possible to mark several options in the appropriate column if needed",
      assetsInAnnex:
        "Please see the relevant documentation confirming the  source of funds/assets in annex",
      annex: "Annex",
      annexDescription1: "Politically Exposed  Person (PEP) -",
      annexDescription2:
        "a natural person carrying out significant public or political activities (except for middle-and low-ranking officials), including the Head of the State; Head of the Government, member of the Government (Minister), his Deputy; senior official of a government institution; member of the legislative body (Parliament); head of a political union, member of the governing body; member of the Supreme Court or the Constitutional Court or another judicial body whose decisions are appealed in exceptional cases; Auditor General, his Deputy, member of the Court of Auditors; member of the Board of the National (Central) Bank; ambassador, head of diplomatic mission; senior official of Defense (Military) Forces; head of state-owned enterprise, member of a governing body; head of an international organization, deputy head being member of the governing body. Also, their family members belong to the category of Politically Exposed Persons: spouse, sister, brother, parent, child / stepfather and his / her spouse. ",
      annexDescription3:
        "Furthermore, the category of Politically Exposed Persons includes: a natural person who, together with a politically exposed person, is a beneficial owner of a legal entity, an unregistered organizational entity or a trust or a legal structure similar to a trust, or who otherwise has a close business relationship therewith; also, a natural person who is the beneficial owner of a legal entity, an unregistered organizational entity or a trust or a legal structure similar to a trust created de facto (informally) in favour of a politically exposed person.",
      annexDescription4:
        " Furthermore, the category of Politically Exposed Persons includes: a natural person who, together with a politically exposed person, is a beneficial owner of a legal entity, an unregistered organizational entity or a trust or a legal structure similar to a trust, or who otherwise has a close business relationship therewith; also, a natural person who is the beneficial owner of a legal entity, an unregistered organizational entity or a trust or a legal structure similar to a trust created de facto (informally) in favour of a politically exposed person.",
      descriptionOfSource: "Description of source of  wealth / funds / assets",
      relevantDocument: "Relevant documents (Due to the bank's request)",
      salaryBonus: "Salary / Bonus",
      dividend: "Dividend",
      saleOfRealEstate: "Sale of real estate / movable property",
      inheritance: "Inheritance",
      financialSupport: "Financial support from family members",
      receivingsFromRent: "Receivings from rent",
      saleOfShares: "Sale of shares / securities",
      businnessActivity: "Business activity",
      compensation: "Compensation",
      cryptocurrency: "Cryptocurrency",
      otherIncome: "Other income",
      certificate: "Certificate from the employing company",
      bankAccount: "Bank account statement",
      bankAccountSalary: "Bank account statement",
      certificateOnIssuing: "Certificate on issuing dividends",
      auditCompany: "Audit company report",
      salesAgreement: "Sales agreement",
      inheritanceCertificate: "Inheritance certificate/will (Copy)",
      courtsDecisionCopy: "Court’s decision (Copy)",
      bankAccountStatement:
        "Bank account statement verifying the receivings from family members.",
      otherOfficialDocument:
        "Other official document verifying the source of funds of family members.",
      rentAgreement: "Rent ageement",
      investmentCertificate: "Investment certificate or agreement",
      confirmationInvestment:
        "Confirmation from the investment or brokerage company",
      businessActivityConfirmation: "Business activity confirmation document",
      latestFinancial: "Latest financial statements",
      courtsDecision: "Court’s decision",
      screenshot:
        "Screenshot of e-wallet or personal page on the exchange market",
      relevantOfficial: "Relevant official verification document",
      company_name: "Name of the client",
      registration_date: "Incorporation date",
      registration_country: "Incorporation country",
      company_legal_address: "The legal address of company Juridical address",
      company_address: "The legal address of company",
      company_actual_address: "Actual/Business address",
      company_web_site: "Company’s web-site",
      business_activity_details:
        "Detailed description of business activity (i.e. Business sector; Type and field of activity Type of goods/Service provided, etc.)",
      owner_name: "Full name",
      beneficialOwner: "Ultimate Beneficial owner",
      addBeneficialOwner: "Add Ultimate Beneficial owner",

      owner_personal_id_number: "Personal Number",
      business_activity_in_georgia:
        "Do you conduct business activity in Georgia?",
      business_activity_in_georgia_additional:
        "Please provide the information related to connection with Georgia and purpose of the bank account in mentioned country.",
      company_connection_to_georgia:
        "The connection of the company's activities with Georgia",
      company_export_connections:
        "Business activity of the company is related to import/export?",
      company_export_connections_additional:
        "Please indicate the the transportation route, country of origin/delivery of goods and role of Georgia in a whole process",
      estimated_money_turnover:
        "Estimated total monthly cash turnover on accounts (GEL)",
      turnover_description_legal:
        "(Turnover refers to the sum of debit and credit turnovers)",
      estimated_cash_turnover:
        "Estimated monthly cash turnover  on accounts (GEL)",
      estimated_cash_turnoverInfo:
        "Turnover refers to the sum of cash debit and credit turnovers",
      counterparties_description: "Information on counterparties",
      counterparties_descriptionInfo:
        " E.g. name, country, line of business; upon request the client must provide  mutually signed agreement(s) with the counterparties",
      company_banks:
        "Name of Banks where the company holds / held bank accounts",
      owner_sources_of_founds:
        "Source of funds/Income of Ultimate Beneficial owner",
      owner_sources_of_founds_descriptionInfo:
        "Information about  the source of income not related to the existing business activity",
      owner_assets_sources:
        "Source of assets / wealth (except funds) of Ultimate Beneficial owner (It is mandatory to submit relevant documentation according to annex due to the bank request)",
      income_from_other_business_activity:
        "Income from other business activity (please specify the company name)",
      other_business_activity: "Other (Please specify)",
      invested_founds_sources:
        "Source of funds invested in the inicial capital for the company’s establishment.",
      bank_money_sources:
        "Source of current funds/income of the company's bank account",
      owner_wealth_sources:
        "Source of assets / wealth (except funds) of Ultimate Beneficial owner",
      other_owner_wealth_sources: "Other source (Please specify)",
      products_and_cervices_you_use: "Which services/products would you use",
      enter_valid_email: "please enter a valid email",
      table_company_money_sources: "Source of funds/income of the company",
      table_relevant_documents:
        "Relevant documents (Due to the bank’s request)",
      table_founders_savings: "Founder’s savings",
      table_bank_account_statement: "Bank account statement",
      table_document_verifying_income:
        "Relevant official document verifying the income needed for savings.",
      table_founders_investments: "Founder’s investments",
      table_document_verifying_investment: "Document verifying the investment",
      table_income_from_business_activity: "Income from business activity",
      table_relevant_financial_declarations:
        "Relevant financial statements/declarations",
      table_audit_report_to_financial_situation:
        "Audit report related to company’s financial situation",
      table_loan: "Loan",
      table_loan_agreement: "Loan agreement",
      table_grants: "Grants",
      table_grants_agreements: "Grant agreements",
      table_donations_charities: "Donations/Charities",
      table_account_statement: "Bank account statement",
      table_funding_from_budget: "Funding from the national budget",
      table_relevant_contract: "Relevant agreement/Contract",
      table_source_of_founds_wealth_beneficial:
        "Source of  wealth/funds/assets of ultimate beneficial owner",
      table_Income_from_business_activities:
        "Income from business activity (Dividend/Salary)",
      table_certificate_dividend_salary_exit:
        "Certificate from the company issuing dividend/salary.",
      table_bank_statement_where_salary_dividends_credited:
        "Bank account statement where the salary/dividend is credited.",
      table_sales_in_year: "Sales of shares",
      table_shares_sales_agreement: "Shares sales agreement",
      table_OtherDocument_to_confirm_family_member_founds:
        "Other official document verifying the source of funds of family members.",
      table_owner_beneficial:
        "– a natural person(s) who is the last possessor or the last controller of a client and/or on whose behalf a transaction is prepared, made or completed. A beneficial owner of legal entity  shall be the direct or indirect ultimate owner, who possesses directly or indirectly, 25% or more than 25% of the holdings or voting shares of mentioned legal entity, or otherwise provides ultimate control over said legal person.",
      table_owner_beneficial_title: "Ultimate Beneficial Owner",
      kycFormTitle: 'Select the "Know Your Customer" (KYC) questionnaire form',
      company_name_desc:
        "(Please indicate the name of the company/organization and describe the field and the subject of activity in detail) ",
      Entrepreneur:
        "(Please describe the field and the subject of activity in detail)",
      is_exp_imp_company: "Is the company's activity related to export/import?",
      please_indicate_countries_related_to_transfers:
        "Please indicate the countries related to wire transfers",
      legal_pep_question:
        "Is Ultimate Beneficial owner / the family member of beneficial owner politically exposed person?",
      mobilenumberChange: "Mobile number add/change",
      emailChange: "Email add/change",
      cancelMobileNumber: "Existing mobile number cancelation",
      cancelEmail: "Existing Email cancelation",
      blockedError: "You are blocked for  24 hours. Please, try later.",
      hasAlreadyAccountsError:
        "You have opened accounts, please contact the bank for information",
      conditions: "Conditions",
      aboutTheOrganization: "About the organization",
      authorizedPerson: "Representative person",
      aboutServices: "About services",
      condition1: "The organization is incorporated in Georgia.",
      condition2:
        "The director (representative) who opens an account is a citizen of Georgia or has permanent residence permit and has the right to represent the organization independently.",
      condition3:
        "All other directors (representatives) of the organization are citizens of Georgia or citizens of the",
      condition3ending: "or has permanent residence permit.",
      condition4:
        "All legal entities owning the organization are established in Georgia or the",
      condition5:
        "All ultimate beneficial owners of the organization are citizens of Georgia or citizens of the",
      condition6:
        "The account can be opened if all beneficiary owner has permanent residence permit of Georgia and at the same time a citizen of the",
      condition7:
        "The field of activity of the organization is not associated with crypto assets, Forex, or free industrial zones.",
      checkDocuments: "Please check out the",
      checkDocuments2: "required for opening an account.",
      documents: "documents",
      crsFormLink: "Information about CRS Self Certification",
      listedCountries: " listed countries. ",
      listedCountry: "  listed countries. ",
      listedCountryWithoutDot: "  listed countries ",
      citizens: " ",
      listOfCountries: "List of countries ",
      accountOpening:
        "If you meet the above conditions, please continue with the account opening process.",
      countryOfIncorporation: "Country of incorporation",
      georgianLetters: "Enter the name in Georgian letters",
      name_of_company: "Name of company",
      latinLetters: "Enter the name in Latin letters",
      allowed: "Maximum allowed 26 symbols ",
      allowed2: "Allowed characters: [A-Z],[0-9],[-/,’&.],[ space]",
      openAccount1: "To open an account, please fill in an",
      openAccount2: "or visit a branch",
      appliaction: "application",
      monthly_turnovers_legal:
        "Amount of expected turnover at the bank per month (GEL)",
      monthly_cash_turnovers_legal:
        "Amount of expected cash turnover at the bank per month (GEL)",
      Number_of_employees: "Number of employees",
      write_number_of_employees: "Write number of employees",
      taxation_under_FATCA:
        "Is the organization subject to taxation under FATCA?",
      politically_exposed_person:
        "Is he/she a politically exposed person (PEP)?",
      director_pep: "One of the directors",
      beneficial_owners_PEP: "One of the beneficial owners",
      search: "search",
      legal_economic_activity:
        "The subject of economic activity (Indicate all fields, which are your activities)",
      additional_information:
        "Additional information related to economic activity",
      service_packages: "Service package",
      service_full_packages: "Complete service package",
      legal_purpose_placeholder: "Purpose of opening account",
      main_economic_activity: "Main subject of economic activity",
      company_registration_date: "Incorporation date",
      company_juridical_address:
        "The legal address of company Juridical address",
      company_web_page: "Company’s web-site ",
      requireCheckPep: "Please check the pep status of the beneficial owner.",
      add: "add",
      delete: "delete",
      purposeOfTheIdentification: "Specify the purpose of the identification:",
      allowed_characters_is_4000: "The number of allowed characters is 4000",
      consent_mark_purpose_header:
        "Consent to data processing for marketing purposes",

      consent_data_verification_header:
        "Consent to data verification in the Credit Information database",
      consent_data_verification_lepl_header:
        "Consent to data verification in the LEPL Revenue Service database",
      MyProfile_UpdateData_Kyc_AdditionalInformation: "Additional Information",
      MyProfile_UpdateData_Kyc_Legal_UltimateBeneficial:
        "Ultimate Beneficial Owner",
      MyProfile_UpdateDat_Kyc_Legal_UltimateBeneficialAdditionInfoPartOne:
        "- a natural person(s) who is the last possessor or the last controller of a client and/or on whose behalf a transaction is prepared, made or completed.",
      MyProfile_UpdateDat_Kyc_Legal_UltimateBeneficialAdditionInfoPartTwo:
        "A beneficial owner of legal entity shall be the direct or indirect ultimate owner, who possesses directly or indirectly, 25% or more than 25% of the holdings or voting shares of mentioned legal entity, or otherwise provides ultimate control over said legal person.",
      MyProfile_UpdateData_Kyc_Legal_PoliticallyExposedPerson:
        "Politically exposed person (PEP)",
      additionalInfo_Text_PEP_Info1:
        " - a natural person carrying out significant public or political activities (except for middle-and low-ranking officials), including the Head of the State; Head of the Government, member of the Government (Minister), his Deputy; senior official of a government institution; member of the legislative body (Parliament); head of a political union, member of the governing body; member of the Supreme Court or the Constitutional Court or another judicial body whose decisions are appealed in exceptional cases; Auditor General, his Deputy, member of the Court of Auditors; member of the Board of the National (Central) Bank; ambassador, head of diplomatic mission; senior official of Defense (Military) Forces; head of state-owned enterprise, member of a governing body; head of an international organization, deputy head being member of the governing body. Also, their family members belong to the category of Politically Exposed Persons: spouse/a person with whom a politically active person is permanently involved in a joint household, sister, brother, parent, child/stepchild and his/her spouse/a person with whom a person is permanently involved in a joint household.",
      additionalInfo_Text_PEP_Info2:
        "Furthermore, the category of Politically Exposed Persons includes: a natural person who, together with a politically exposed person, is a beneficial owner of a legal entity, an unregistered organizational entity or a trust or a legal structure similar to a trust, or who otherwise has a close business, social or political relationship therewith; also, a natural person who is the beneficial owner of a legal entity, an unregistered organizational entity or a trust or a legal structure similar to a trust created de facto (informally) in favour of a politically exposed person.",
      Source_of_funds: "Source of funds/income of the company",
      Source_of_wealth:
        "Source of wealth/funds/assets of ultimate beneficial owner",
      consent_data_income_remittance_header:
        "Consent to Handle Income from Remittance Transactions",
      read_more: "Read More",
      hide: "Hide",
      ...TRANSLATION_EN,
    },
  },
  ka: {
    translation: {
      username: "სახელი",
      videoIdentity: "ვიდეო იდენტიფიკაცია",
      online: "ონლაინ",
      languageGe: "GE",
      languageEn: "ENG",
      title: "სათაური",
      confirmation: "დადასტურება",
      documentNumber: "დოკუმენტის ნომერი",
      Cancel: "უარყოფა",
      confirmationText:
        "ანგარიშის გახსნა შეუძლია ფიზიკურ პირს, საქართველოს მოქალაქის პირადობის მოწმობით, პასპორტით, ან მუდმივი ბინადრობის მოწმობით",
      step2ConfirmText: "თქვენ წარმატებით გაიარეთ ვიდეო იდენტიფიკაცია",
      name: "სახელი",
      lastName: "გვარი",
      birthDay: "დაბადების თარიღი",
      PhoneNumber: "მობილურის ნომერი",
      age: "ასაკი",
      citizenship: "მოქალაქეობა",
      city: "ქალაქი",
      city_name: "ქალაქის დასახელება",
      country_code: "აირჩიეთ სატელეფონო კოდი",

      birth_city: "დაბადების ქალაქი",
      village_name: "სოფლის დასახელება",
      village: "სოფელი",
      country: "ქვეყანა",
      street: "ქუჩა",
      homeNumber: "სახლის ნომერი",
      idNumber: "პირადი ნომერი",
      sex: "სქესი",
      next: "გაგრძელება",
      prev: "უკან",
      required: "გთხოვთ, შეავსოთ მონიშნული ველი",
      requiredSelect: "გთხოვთ, მონიშნოთ სასურველი ველი. ",
      requiredConfirm: "გთხოვთ, დაადასტუროთ.",
      address: "მისამართი",
      typeAddress: "შეიყვანეთ მისამართი",
      resident: "რეზიდენტი",
      nonResident: "არარეზიდენტი",
      email_address: "ელ.ფოსტის მისამართი",
      email: "ელ.ფოსტა",
      validEmail: "შეიყვანეთ ვალიდური ელ ფოსტა",
      yes: "კი",
      no: "არა",
      birthCountry: "დაბადების ქვეყანა",
      cityzenShipCountry: "აირჩიე ქვეყანა",
      agreementText:
        "სს პროკრედიტ ბანკი უფლებამოსილია, აღნიშნული განაცხადის განხილვისა და საბანკო მომსახურების გაწევის მიზნით, კანონმდებლობით დადგენილი წესითა და აღნიშნული მიზნის განსახორციელებლად საჭირო მოცულობით, დაამუშაოს ჩემი პერსონალური მონაცემები, მათ შორის იდენტიფიკაციის პროცესში მოპოვებული ფოტო/ვიდეო მასალა და ბიომეტრიული მონაცემები (სახის მახასიათებლები). ასევე იდენტიფიკაციის მიზნით ზემოთ მითითებული მონაცემები ხელმისაწვდომი გახადოს პროგრამული უზრუნველყოფის მომწოდებელი მესამე პირისთვის (Identomat Inc ). ასევე, თანახმა ვარ სს პროკრედიტ ბანკმა მიიღოს და დაამუშაოს სსიპ სახელმწიფო სერვისების განვითარების სააგენტოს მონაცემთა ბაზაში არსებული ჩემი პერსონალური მონაცემები.",
      agreementText2:
        "ვაცნობიერებ, რომ ბიომეტრიული მონაცემების დამუშავება აუცილებელია უტყუარი იდენტიფიკაციისთვის. ჩემთვის ცნობილია, რომ  ბანკი მონაცემებს ინახავს და ამუშავებს დაცულ სერვერზე. ასევე, მონაცემების გადაცემა ხდება მხოლოდ დაცული საკომუნიკაციო არხით. ბანკი უზრუნველყოფს ინფორმაციის დაცვას შემთხვევითი ან უკანონო განადგურებისაგან, შეცვლისაგან, გამჟღავნებისაგან, მოპოვებისაგან, ნებისმიერი სხვა ფორმით უკანონო გამოყენებისა და შემთხვევითი ან უკანონო დაკარგვისაგან.",
      agreementText3:
        "გაცნობიერებული მაქვს კანონმდებლობით გათვალისწინებული უფლებები, რომ მოთხოვნის შემთხვევაში, მონაცემთა დამმუშავებელი ვალდებულია გაასწოროს, განაახლოს, დაამატოს, დაბლოკოს, წაშალოს ან გაანადგუროს მონაცემები, თუ ისინი არასრულია, არაზუსტია, არ არის განახლებული ან თუ მათი შეგროვება და დამუშავება განხორციელდა კანონის საწინააღმდეგოდ.",
      agreementText4: `ვადასტურებ, რომ გავეცანი სს „პროკრედიტ ბანკის“ ინტერნეტ გვერდზე www.procreditbank.ge განთავსებულ`,
      agreementLinkText1: " “საბანკო მომსახურების პირობებს“",
      and: " და ",
      agreementLinkText2: "მომსახურების ტარიფებს",
      agreement4Last:
        ", ვეთანხმები და ვკისრულობ მათი შესრულების ვალდებულებას. მოვახდინე დოკუმენტების შენახვა და/ან ამობეჭდვა ისე, რომ ჩემთვის ხელმისაწვდომია ინფორმაცია საბანკო პროდუქტების შესახებ.",
      agreementText5:
        "თანახმა ვარ, ბანკთან ურთიერთობისთვის გამოვიყენო პირადობის დამადასტურებელ დოკუმენტში დაფიქსირებული ხელმოწერა (ხელმოწერის ნიმუში).",
      agreementText6:
        "ჩემთვის ცნობილია, რომ ამ ფორმის შევსება არ ნიშნავს პროკრედიტ ბანკში ანგარიშის და სერვისების სავალდებულო გახსნას.",
      agreementText7:
        "ჩემთვის ცნობილია, რომ ანგარიშების/სერვისების რეგისტრაციიდან ორი კვირის განმავლობაში ბანკში მოქმედი პირობების შესაბამისად ინტერნეტ ბანკით ხელშეკრულებების დაუდასტურებლობის შემთხვევაში ანგარიშ(ებ)ი/სერვის(ებ)ი ავტომატურად დაიხურება.",
      confirmationStep1: "თანხმობა",
      identificationStep2: "იდენტიფიკაცია",
      identityInformation3: "თქვენ შესახებ",
      identityInformationUpdate3: "მონაცემების განახლება",
      identityInformation4: "პირადი ინფორმაცია",
      identityInformation5: "სერვისების შესახებ",
      identityInformation6: "დადასტურება",
      cityVillage: "ქალაქი / სოფელი",
      notValidEmail: "არავალიდური ელ-ფოსტა",
      notValidPhone: "შეიყვანეთ ვალიდური მობილურის ნომერი",
      chooseCountry: "აირჩიეთ ქვეყანა",
      brithCountry: "დაბადების ქვეყანა",
      errorText: "თქვენი იდენტიფიკაცია წარუმატებელია, გთხოვთ, სცადოთ ხელახლა.",
      isActualAddress:
        "გთხოვთ, შეავსოთ იმ შემთხვევაში, თუ თქვენი იურიდიული მისამართი განსხვავდება ფაქტიური მისამართისგან",
      isActualEmailAddress:
        "შეავსეთ საფოსტო მისამართი, თუ ის განსხვავებულია რეზიდენტობის მისამართისგან",
      actualCityVillage: "ფაქტიური მისამართი",
      haveDualCitizenShip: "ორი ქვეყნის მოქალაქე ხომ არ ხარ?",
      haveAnotherCountryResidence:
        "ხართ რომელიმე ქვეყნის რეზიდენტი საქართველოს გარდა?",
      currentResidenceCountry: "მიმდინარე რეზიდენტობის ქვეყანა",
      currentResidenceCity: "მიმდინარე რეზიდენტობის ქალაქი",
      currentResidenceAddress: "მიმდინარე რეზიდენტობის მისამართი",
      currentResidencePostalCode: "მიმდინარე რეზიდენტობის საფოსტო ინდექსი",

      countryOfTaxResidence: "საგადასახადო რეზიდენტობის ქვეყანა",
      ifHaveLocaTaxIdentificationNumber:
        "გაქვთ თუ არა ლოკალური საგადასახადო საიდენტიფიკაციო ნომერი (TIN)?",
      locaTaxIdentificationNumber:
        "ლოკალური საგადასახადო საიდენტიფიკაციო ნომერი (TIN)",
      tinType: "TIN ტიპი",
      explainUnableTinReason:
        "გთხოვთ, განმარტოთ, თუ რატომ ვერ ხდება TIN-ის მოძიება",

      tinIsNotAvailable: "თუ TIN მისაწვდომი არ არის, აირჩიეთ მიზეზი",
      notIssuingTin:
        "ქვეყანა, სადაც ანგარიშის მფლობელი ვალდებულია გადაიხადოს გადასახადი, არ გასცემს  TIN-ებს საკუთარ რეზიდენტებზე",
      otherwiseUnable:
        "ანგარიშის მფლობელს არ შეუძლია მოიძიოს TIN ან სხვა შესაბამისი საგადასახადო ნომერი",
      disclosureOfTINIsNotRequired:
        "TIN-ის გამჟღავნება არ მოითხოვება შესაბამისი ქვეყნის საგადასახადო ორგანოს მიერ",

      step3AcceptanceText1:
        "ფორმაში მოცემულ მონაცემთა ბანკის მიერ დამუშავების საჭიროება გამომდინარეობს საქართველოს ფინანსთა მინისტრის ბრძანება №125 „საგადასახადო საკითხებში ადმინისტრაციული  ურთიერთდახმარების  შესახებ“ 1988 წლის 25 იანვრის კონვენციის ფარგლებში „ფინანსური ანგარიშების შესახებ ინფორმაციის ავტომატური გაცვლის შესახებ“ კომპეტენტური  უწყებების მრავალმხრივი  შეთანხმებით (CRS MCAA) ან საქართველოსა და შესაბამის იურისდიქციას  შორის ფინანსური ანგარიშების თაობაზე ინფორმაციის  ავტომატური  გაცვლის შესახებ შეთანხმებით გათვალისწინებული ანგარიშგების წესით ბანკისთვის დაკისრებული მოვალეობების შესასრულებლად.",
      step3AcceptanceText2:
        "ვიაზრებ, რომ ამ ფორმაში მოცემული ანგარიშგებას დაქვემდებარებულ ანგარიშ(ებ)თან დაკავშირებული ინფორმაცია შეიძლება მიეწოდოს იმ ქვეყნის საგადასახადო ორგანოებს, სადაც ეს ანგარიში(ებ)ი არსებობს და გაიცვალოს სხვა ქვეყნის/ქვეყნების საგადასახადო ორგანოებთან, სადაც ანგარიშის მფლობელი შეიძლება იყოს საგადასახადო რეზიდენტი სამთავრობათაშორისო შეთანხმებების შესაბამისად.",
      step3AcceptanceText3:
        "ვადასტურებ, მოცემული ინფორმაციის სისწორეს. ვიღებ ვალდებულებას, მონაცემების ცვლილების შემთხვევაში, ცვლილებიდან 30 დღის განმავლობაში ბანკში განვაახლო მონაცემები.",
      genderMale: "მამრობითი",
      genderFeMale: "მდედრობითი",
      fillLegalAddress: "გთხოვთ, შეავსოთ იურიდიული მისამართი",
      legalAddressFilled: "იურიდიული მისამართი",
      fillFizicalAddress: "გთხოვთ, შეავსოთ ფაქტიური მისამართი",
      fatca:
        "ხართ თუ არა აშშ-სთან დაკავშირებული პირი ფინანსურად ან სხვა ნებისმიერი ფორმით (საცხოვრებელი მისამართით, ტელეფონის ნომრით) ან დაბეგვრის სუბიექტი FATCA-ს შესაბამისად?",
      green_card: "ხართ თუ არა Green Card-ის მფლობელი?",
      federal_tax:
        "მონიშნეთ ფედერალური საგადასახადო კლასიფიკაციის შესაბამისი უჯრა:",
      federal_tax_classification: "ფედერალური საგადასახადო კლასიფიკაცია ",
      comment: "კომენტარი",
      write_comment: "დაწერეთ კომენტარი",
      address_placeholder: "ნომერი, ქუჩა, ბინის ან ოფისის ნომერი",
      street_placeholder: "ქალაქი, სახელმწიფო და საფოსტო ინდექსი",
      account_nums: "ანგარიშის ნომერ(ებ)ი",
      account_nums_placeholder: "ჩამოთვალეთ ანგარიშის ნომერ(ებ)ი",
      TIN: "გადამხდელის საიდენტიფიკაციო ნომერი (TIN)",
      federal_comment:
        "საგადასახადო კლასიფიკაცია (C კორპ., S კორპ., P=ამხანაგობა)",
      fatca_privacy:
        "წინამდებარე დოკუმენტზე გამოვხატავ თანხმობას ჩემი პერსონალური მონაცემების დამუშავებაზე FATCA-ს რეგულაციებისა და მიზნების შესაბამისად.",
      account_services:
        "ანგარიშის გახსნის მიზანი და მოსალოდნელი გარიგებების ხასიათი",
      fatcaPrivacy:
        "წინამდებარე დოკუმენტზე ხელმოწერით გამოვხატავ თანხმობას ჩემი პერსონალური მონაცემების დამუშავებაზე FATCA-ს რეგულაციებისა და მიზნების შესაბამისად.( სავალდებულოდ მოსანიშნი, თუ ზედა ველები შეივსო)",
      money_transfer_from: "ჩარიცხვის ქვეყნები",
      money_transfer_to: "გადარიცხვის ქვეყნები",
      pep: "ხართ თუ არა პოლიტიკურად აქტიური პირი, ან დაკავშირებული თუ ხართ ასეთ პირებთან?",
      pepCategory:
        "თქვენ ან თქვენი ოჯახის წევრი მიეკუთვნებით პოლიტიკურად აქტიური პირის (პეპ) კატეგორიას? (პეპ-ის განმარტება გთხოვთ იხილოთ დანართში)დადებითი პასუხის შემთხვევაში მიუთითეთ დამატებითი დეტალები",
      select: "აირჩიეთ",
      select_1: "აირჩიეთ...",
      legal_form: "სამართლებრივი ფორმა",
      select_activity_subject: "აირჩიეთ თქვენი საქმიანობის საგანი",
      activity_subject: "საქმიანობის საგანი",
      income_source: "შემოსავლის წყარო",
      employment_status: "დასაქმების სტატუსი",
      write_income_source: "აირჩიეთ თქვენი შემოსავლის წყარო",
      monthly_turnovers: "ყოველთვიური ბრუნვების ოდენობა ლარში",
      write_monthly_turnovers:
        "აირჩიეთ თქვენი ყოველთვიური ბრუნვების ოდენობა ლარში",
      workspace: "სამუშაო ადგილი",
      position: "პოზიცია",
      workplace: "დამსაქმებელი კომპანიის დასახელება",
      write_workspace: "ჩაწერეთ თქვენი სამუშაო ადგილი",
      write_monthly_income: "აირჩიეთ თქვენი ყოველთვიური შემოსავალი ლარში",
      monthly_income: "ყოველთვიური შემოსავლის ოდენობა  ლარში",
      position: "პოზიცია",
      write_position: "ჩაწერეთ თქვენი პოზიცია სამსახურში",
      start_date: "სამსახურის დაწყების თარიღი",
      turnovers_definition:
        "ბრუნვაში იგულისხმება დებეტური და კრედიტული ბრუნვების ჯამი",
      turnoversDefinition:
        "ბრუნვა გულისხმობს  დებეტური და კრედიტული ბრუნვების ჯამს",
      TIN_definition:
        "შეიყვანეთ თქვენი გადამხდელის საიდენტიფიკაციო  ნომერი (TIN) შესაბამის ველში. გადახდის წყაროსთან საშემოსავლო გადასახადის ორჯერ დაკავების  თავიდან აცილების მიზნით, მითითებული TIN უნდა შეესაბამებოდეს „სახელის“ ველში მითითებულ სახელს. ფიზიკური პირებისათვის, ეს არის თქვენი სოციალური უზრუნველყოფის ნომერი (SSN). სხვა პირებისთვის, ეს არის თქვენი დამსაქმებლის საიდენტიფიკაციო ნომერი (EIN).",
      female: "მდედრობითი/Female",
      male: "მამრობითი/Male",
      currentAccount: "მიმდინარე ანგარიში",
      currentyAccountDesc: "GEL, USD, EUR.",
      currentyAccountDescription: "GEL, USD, EUR.",
      seeRates: " იხილეთ ტარიფები.",
      GEL: "ლარი",
      USD: "დოლარი",
      EUR: "ევრო",
      currentAccountSub:
        "მომსახურების ტარიფი განისაზღვრება ანგარიშის რაოდენობის მიხედვით,",
      seeTariffs: "იხილეთ ტარიფები.",
      savingAccount: "შემნახველი ანაბარი",
      savingAccountDesc: "GEL, USD, EUR.",
      minimal: "დაასრულეთ რეგისტრაცია, გაიაქტიურეთ ნაკრები ",
      minimalAccount: "„მინიმალი“ ",
      getMinimal: "და ისარგებლეთ მომდევნო 1 თვე უფასო სერვისებით:",
      standart:
        "1 თვის განმავლობაში აირჩიეთ ბანკის მიერ შემოთავაზებული ნაკრებიდან ერთ-ერთი, სხვა შემთხვევაში ავტომატურად გაგიაქტიურდებათ ",
      standartAccount: "„ანგარიში სტანდარტი“",
      forYou: ".",
      smsService: "SMS მომსახურება",
      smsServiceDesc: "შეტყობინებას მიიღებთ ტრანზაქციების შესახებ.",
      smsServiceDescription:
        "მიიღებთ შეტყობინებას ანგარიშზე განხორციელებული ტრანზაქციების შესახებ.",
      chooseLanguage: "აირჩიეთ სასურველი ენა:",
      georgian: "ქართული",
      english: "ინგლისური",
      internetBank: "ინტერნეტ ბანკი",
      // chooseMeans:
      //   'აირჩიეთ ინტერნეტ ბანკის  მომხმარებლის სახელის და პაროლის მიღების წყარო:',
      internetBankDescription:
        "დისტანციური მომსახურების არხი, თანამედროვე გზა თქვენი საბანკო ანგარიშების მართვისთვის.",
      sourceForInternetBank:
        "აირჩიეთ ინტერნეტ ბანკის  მომხმარებლის სახელის და პაროლის მიღების წყარო:",
      mobilePhoneNum: "მობილური ტელეფონის ნომერი",
      both: "ორივე",
      fullVersion: "სრული ვერსია",
      bankCard: "საბანკო ბარათი",
      // plasticCardDescStart: 'მასტერქარდ სადებეტო ბარათი',
      // plasticCardDescEnd:
      //   ' რომლითაც  შეგიძლიათ  თანხის შეტანა/გატანა, ინტერნეტ შესყიდვები და პოს-ტერმინალით გადახდები.',
      note: "ყურადღება!",
      cardNote:
        "ანგარიშის გახსნის შემდეგ, პლასტიკური ბარათის შეკვეთა ხდება კლიენტის მიერ ინტერნეტ ბანკიდან.",
      direct: "დაირექთი",
      greenCard: "მწვანე ბარათი (Green Card)",
      greenCardOwner: "ხართ აშშ-ს მწვანე ბარათის მფლობელი?",
      usaTaxPayerQuestion: "ხართ აშშ-ს გადასახადის გადამხდელი?",
      greenCardTitle: "Green Card",
      chooseBaseAccount: "საბანკო სერვისის ასარჩევად, დააჭირეთ ბარათს",
      enterValidDate: "შეიყვანეთ ვალიდური თარიღი",
      PEP_meaning: "პოლიტიკურად აქტიური პირი",
      PEP_desc:
        " <bold>პოლიტიკურად აქტიური პირი</bold> - მნიშვნელოვანი საჯარო ან პოლიტიკური ფუნქციების შემსრულებელი ფიზიკური პირი (გარდა საშუალო და დაბალი რანგის თანამდებობის პირებისა), მათ შორის: სახელმწიფოს მეთაური, მთავრობის ხელმძღვანელი, მთავრობის წევრი (მინისტრი), მისი მოადგილე, სამთავრობო დაწესებულების ხელმძღვანელი; საკანონმდებლო ორგანოს (პარლამენტის) წევრი; პოლიტიკური გაერთიანების ხელმძღვანელი, მმართველი ორგანოს წევრი; უზენაესი სასამართლოს, საკონსტუტიციო სასამართლოს, უმაღლესი ინსტანციის სხვა სასამართლო ორგანოს წევრი, რომლის გადაწყვეტილებები გამონაკლის შემთხვევაში საჩივრდება; გენერალური აუდიტორი, მისი მოადგილე, აუდიტორთა სასამართლოს წევრი; ეროვნული (ცენტრალური) ბანკის საბჭოს წევრი; ელჩი, დიპლომატიური წარმომადგენლობის ხელმძღვანელი; თავდაცვის (სამხედრო) ძალების ხელმძღვანელი თანამდებობის პირი; სახელმწიფოს წილობრივი მონაწილეობით მოქმედი საწარმოს ხელმძღვანელი, მმართველობის ორგანოს წევრი; საერთაშორისო ორგანიზაციის ხელმძღვანელი, მისი მოადგილე მმართველობის ორგანოს წევრი. ასევე, პოლიტიკურად აქტიური პირის კატეგორიას მიეკუთვნებიან მათი ოჯახის წევრები: მეუღლე/პირი, რომელთანაც პოლიტიკურად აქტიური პირი მუდმივად ეწევა ერთიან საოჯახო მეურნეობას, და, ძმა, მშობელი, შვილი/გერი და მისი მეუღლე/პირი რომელთანაც ის მუდმივად ეწევა ერთიან საოჯახო მეურნეობას. <lb /> <lb /> გარდა ამისა, პოლიტიკურად აქტიური პირების კატეგორიაში შედის: ფიზიკური პირი, რომელიც პოლიტიკურად აქტიურ პირთან ერთად არის იურიდიული პირის, არარეგისტრირებული ორგანიზაციული წარმონაქმნის ან ტრასტის, ან ტრასტის მსგავსი სამართლებრივი სტრუქტურის ბენეფიციარი მესაკუთრე ან რომელსაც მასთან სხვაგვარი მჭიდრო საქმიანი, სოციალური ან პოლიტიკური ურთიერთობა აქვს; ასევე, ფიზიკური პირი, რომლიც არის ფაქტობრივად (არაფორმალურად) პოლიტიკურად აქტიური პირის სასარგებლოდ შექმნილი იურიდიული პირის, არარეგისტრირებული ორგანიზაციული წარმონაქმნის ან ტრასტის, ან ტრასტის მსგავსი სამართლებრივი სტრუქტურის ბენეფიციარი მესაკუთრე.",
      FATCA_DESC: `FATCA (Foreign Account Tax Compliance Act) ანუ უცხოური ანგარიშების დაბეგვრის კანონის მიზანია აშშ-ის საგადასახადო სამსახურის გამჭვირვალობის გაზრდა აშშ-ის იურისდიქციის ქვეშ არსებულ პირებთან მიმართებაში, რომლებიც შესაძლებელია ახორციელებდნენ ინვესტიციებს და ღებულობდნენ შემოსავალს არაამერიკულ ორგანიზაციებში გახსნილი ანგარიშების მეშვეობით. FATCA-ს დებულებები ითვალისწინებს ზომებს იმისათვის, რომ უცხოურმა ფინანსურმა ორგანიზაციებმა მიაწოდონ ინფორმაცია აშშ-ის შემოსავლების სამსახურს (IRS) აშშ-ის იურისდიქციის ქვეშ მყოფი პირების კუთვნილი საბანკო ანგარიშების შესახებ. FATCA-ს მიხედვით აშშ-ს ინდიციას მიეკუთვნება ნებისმიერი ტიპის ანგარიშის მფლობელი ფიზიკური პირი შემდეგი მაჩვენებლებით: • პირი არის აშშ-ს მოქალაქე ან რეზიდენტი; • პირი ცხოვრობს აშშ-ში და აქვს აშშ-ს მისამართი (ასევე საფოსტო ყუთის მისამართიც); • პირი დაბადებულია აშშ-ში; • პირის საკონტაქტო ნომერია აშშ-ს ტელეფონის ნომერი; • ფიზიკური პირის მინდობილ პირს აქვს აშშ-ს ინდიცია; • პირს ბანკში დარეგისტრირებული აქვს ავტომატური დავალება აშშ-ს საბანკო ანგარიშზე ფულადი სახსრების რეგულარული გადარიცხვის მიზნობრიობით.`,
      WHAT_IS_FATCA: "რა არის FATCA?",
      GREEN_CARD_TOOLTIP:
        "იდენტიფიკაციის ბარათი, რომელიც ადასტურებს აშშ-ს რეზიდენტობას და არა მოქალაქეობას. მფლობელს აძლევს მუდმივი ცხოვრების და მუშაობის უფლებას აშშ-ს ტერიტორიაზე.",
      otpTitle:
        "დარწმუნებული ხართ, რომ გსურთ ერთჯერადი კოდის გაგზავნა ნომერზე {{mobNUmber}}?",
      OtpWarning:
        "ყურადღება! მობილური ტელეფონის დაკარგვის ან ნომრის შეცვლის შემთხვევაში გთხოვთ, დაუყოვნებლივ აცნობოთ ბანკს!",
      OTPYes: "დიახ",
      OTPNo: "არა",
      notValidCountry:
        "ონლაინ იდენტიფიკაციით  ანგარიშის გახსნა ვერ შესრულდება. ანგარიშის გახსნისთვის, გთხოვთ, ეწვიოთ ჩვენს ვებ-გვერდს",
      ourWebSite: "ჩვენს ვებ-გვერდს",
      authenticationCode: "ავთენტიფიკაციის კოდი",
      CodeWillSend:
        "ავთენტიფიკაციის კოდი გამოგეგზავნათ {{number}} ტელეფონის ნომერზე",
      finish: "დასრულება",
      sendSMS: "კოდის გაგზავნა",
      updateOTP: "ხელახლა გაგზავნა",
      finishText: "იდენტიფიკაციის და განაცხადის შევსების პროცესი დასრულებულია.",
      completedSuccessfully: "დასრულებულია წარმატებით!",
      waitForMessage: "დაელოდე ბანკისგან დაკავშირებას.",
      branches: "ფილიალი",
      ByPost: "ფოსტა",
      deliveryMethodLabel: "ბარათის მიღების მეთოდი",
      tbilisi: "თბილისი",
      houseNumber: "სახლის N",
      apartmentNumber: "ბინის N",
      selectBranch: "აირჩიეთ ფილიალი",
      MainCurrency: "ძირითადი ანგარიში",
      currency: "ვალუტა",
      AdditionalAccounts: "დამატებითი ანგარიშ(ებ)ი",
      CardWillDelivered: "ბარათის ფოსტით მიღება შესაძლებელია თბილისში.",
      CardDeliveryTimes:
        "ბარათის მისამართზე ჩაბარება განხორციელდება სამუშაო დღის განმავლობაში 10:00-დან 18:00 სთ-მდე.",
      CardAccountSelectTitle:
        " - აირჩიეთ ბარათის ძირითადი და დამატებითი ანგარიშები.",
      bankCardDesc: "ბარათის შეკვეთა შეგიძლიათ ინტერნეტ ბანკში",
      EstimatedCashFlow:
        "მოსალოდნელი  ნაღდი ფულის თვიური ბრუნვა  ანგარიშებზე (ლარებში)",
      EstimatedCashFlows:
        "ბრუნვა გულისხმობს  ნაღდი ფულის დებეტური და კრედიტული ბრუნვების ჯამს",
      SourceOfCashFunds: "ფულადი სახსრების წარმომავლობის წყარო",
      SourceOfCashFundsConfirmationText:
        "ფულადი სახსრების/შემოსავლების წარმომავლობის წყარო",
      sourceOfProperty: "ქონების (გარდა ფულადი სახსრებისა) წარმომავლობის წყარო",
      banksTitle: "ბანკების დასახელება სადაც ფლობთ საბანკო ანგარიშებს",
      banksConfirmationTitle:
        "ბანკების დასახელება სადაც ფლობთ/ფლობდით საბანკო ანგარიშებს",
      pleaseBeMoreSpecific: "მიუთითეთ დეტალურად",
      pleaseSpecify: "გთხოვთ დააკონკრეტეთ",
      ConfirmInfoInQuestionnaire:
        "ვადასტურებ კითხვარით მოწოდებული ინფორმაციის სისწორეს",
      KycConfirmInfoInQuestionnaire:
        "ვადასტურებ კითხვარით მოწოდებული ინფორმაციის სისწორეს",
      InformationOnCounterparties:
        "მაგ: დასახელება,  ქვეყანა, ბიზნეს საქმიანობა. მოთხოვნის შემთხვევაში კლიენტმა უნდა წარმოადგინოს კონტრაგენტთან/ებთან გაფორმებული ორმხრივად ხელმოწერილი ხელშეკრულება",
      InformationOnCounterpartiesPlaceholder: "ინფორმაცია კონტრაგენტებზე",
      date: "თარიღი",
      BirthPlace: "დაბადების ადგილი",
      dualCitizenship: "ორმაგი მოქალაქეობა",
      activityField: "საქმიანობის სფერო",
      montly_turnovers_title:
        "მოსალოდნელი ჯამური თვიური ბრუნვა  ანგარიშებზე (ლარებში)",
      // PEP_confirm_title:
      //   "მიეკუთვნებით პოლიტიკურად აქტიური პირის (პეპ) * კატეგორიას ?",
      otherBank: "სხვა ბანკი",
      otherIncomes: "სხვა შემოსავლები",
      otherSourceOfProperty: "ქონების წარმომავლობის სხვა წყარო",
      infoAboutDocumentationRequest:
        "(მოთხოვნის შემთხვევაში აუცილებელია დოკუმენტაციის წარმოდგენა)",
      infoAboutSubmitRelevantDocumentationRequest:
        "(ბანკის მოთხოვნის შემთხვევაში აუცილებელია დოკუმენტაციის წარმოდგენა)",
      infoAboutSubmitDocumentationRequest:
        "(ბანკის მოთხოვნის შემთხვევაში აუცილებელია დანართით გათვალისწინებული დოკუმენტაციის წარმოდგენა)",
      knowYourClient: "კითხვარი იცნობდე შენს კლიენტს",
      CRSSelfDeclaration: "CRS თვითდეკლარაციის ფორმა ფიზიკური პირებისთვის",
      applicationForm4: "განაცხადის ფორმა",
      PrivateIndividual: "ფიზიკური პირი",
      LegalEntity: "იურიდიული პირი",
      fullName: "კლიენტის სახელი და გვარი",
      personalNumber: "პირადი ნომერი",
      NameOfCompany: "ორგანიზაციის დასახელება",
      IdentificationNumber: "საიდენტიფიკაციო კოდი",
      DirectorFullName: "დირექტორის სახელი და გვარი",
      PersonalNumberOfTheDirector: "დირექტორის პირადი ნომერი",
      TelephoneNumber: "ტელეფონის ნომერი",
      PEPCreditInfo:
        "პოლიტიკურად აქტიური პირის შემთხვევაში მონიშნეთ ღილაკი ,,დიახ“",
      confirmationButton: "(თანხმობის მოსანიშნი ღილაკი)",
      construction: "ფორმა დამუშავების პროცესშია",
      mobileNumber: "მობილური ტელეფონის ნომერი:",
      EmailAddress: "ელექტრონული ფოსტა:",
      actualAddress: "ფაქტიური მისამართი:",
      contactData: "საკონტაქტო მონაცემები:",
      contactDataChange: "მონიშნეთ, რომელი მონაცემის ცვლილება გსურთ :",
      ChangeContactDataConfirmationText1:
        "ვადასტურებ ზემოაღნიშნული ინფორმაციის სისწორეს. თანახმა ვარ, რომ ბანკმა აღნიშნული ინფორმაცია დააფიქსიროს  თავის მონაცემთა ბაზაში და გამოიყენოს ჩემთან კომუნიკაციისათვის. წინამდებარე მომსახურებაზე ვრცელდება ",
      ChangeContactDataConfirmationText2:
        ", რომლითაც განსაზღვრულია აღნიშნული მომსახურების შინაარსი და ყველა პირობა.",
      ServiceConditions: "„საბანკო მომსახურების პირობები“",
      identificationNumberInfo:
        "ნომერი აღებულია იდენტიფიკაციის პროცესიდან. თუ გსურთ ცვლილება, იდენტიფიკაცია გაიარეთ სასურველი ნომრით.",
      identificationEmailInfo:
        "ელ.ფოსტა აღებულია იდენტიფიკაციის პროცესიდან. თუ გსურთ ცვლილება, იდენტიფიკაცია გაიარეთ სასურველი  ელ. ფოსტით.",
      requiredConfirmation: "გთხოვთ, დაადასტუროთ ზემოაღნიშნული ინფორმაცია",
      TickDesiredBox: "გთხოვთ, მონიშნეთ სასურველი ველი",
      sms: "სმს",
      passwordSource:
        "მონიშნეთ ინტერნეტ ბანკის ერთჯერადი პაროლის მიღების  წყარო:",
      authenticationPhoneNumber1: "ტელეფონის ნომერი",
      authenticationPhoneNumber2:
        "დაგიფიქსირდებათ ძლიერი ავთენტიფიკაციისა და სმს კოდითვის. ",
      fillQuestionAndAnswer: "შეავსეთ ინტერნეტ ბანკის კოდური კითხვა და პასუხი:",
      codeQuestion: "კოდური კითხვა",
      codeAnswer: "კოდური პასუხი",
      categoryOfPoliticalyExposedPerson:
        "თქვენ ან თქვენი ოჯახის წევრი მიეკუთვნებით პოლიტიკურად აქტიური პირის (პეპ) კატეგორიას?",
      politicallyExposedPerson: "პოლიტიკურად აქტიური პირი",
      familyMemberOfPoliticallyExposedPerson:
        "პოლიტიკურად აქტიური პირის ოჯახის წევრი",
      relationshipWithAPoliticallyExposedPerson:
        "პოლიტიკურად აქტიურ პირთან უშუალო საქმიან ურთიერთობაში მყოფი პირი (პოლიტიკურად აქტიურ პირთან ერთად იურიდიული პირის წილის/აქციების ფლობა/კონტროლი ან სხვაგვარი მჭიდრო საქმიანი ურთიერთობა)",
      informationAboutRelatedPep:
        "დამატებითი დეტალები დაკავშირებული პეპ-ის შესახებ (სახელი, გვარი, თანამდებობა)",
      moreInfoAboutRelatedPep: "დამატებითი დეტალები",
      informationRegardingAssets: "ინფორმაცია ქონების (აქტივების) შესახებ",

      account_services_title_in_KYC_confirm:
        "პროდუქტები/სერვისები რომლითაც სარგებლობთ/ისარგებლებთ პროკრედიტ ბანკში",
      IncomingFrom: "ჩარიცხვის ქვეყნები:",
      OutgoingTo: "გადარიცხვის ქვეყნები:",
      Workplace_business_activity: " საქმიანობის სფერო და საგანი",
      dataUpdate: "აირჩიეთ რომელი მონაცემის განახლება/შეცვლა გსურთ",
      changePhoneSms: "ტელეფონის ნომრის ცვლილება სმს კოდისთვის",
      addPhoneSms: "ტელეფონის ნომრის დამატება სმს კოდისთვის",
      changeAuthenticationNumber: "ძლიერი ავთენტიფიკაციის ნომრის ცვლილება",
      addAuthenticationNumber: "ძლიერი ავთენტიფიკაციის ნომრის დამატება ",
      changeAuthenticationMethod: "ძლიერი ავთენტიფიკაციის მეთოდის ცვლილება",
      changeGenerationTool: "საგენერაციო მოწყობილობის ცვლილება",
      changeIbCode: "ინტერნეტ ბანკის  კოდური  კითხვა -პასუხის ცვლილება",
      changeIbEmailAddress: "ინტერნეტ ბანკის მეილის ცვლილება",
      changeSourceIbPassword: "ინტერნეტ ბანკის პაროლის მიღების წყაროს ცვლილება",
      activateIb: "ინტერნეტ ბანკის გააქტიურება",
      loginWithOneTimeCode:
        "სისტემაში შესვლა დამატებით ერთჯერადი კოდის დადასტურებით.",
      deviceConfirmation:
        "მოწყობილობა, რომელიც გამოიყენება ტრანზაქციების დასადასტურებლად.",
      usernameAndPassswordChannel:
        "არხი, სადაც იგზავნება ინტერნეტ ბანკის მომხმარებლის სახელი და პაროლი",
      smsCode: "სმს  კოდი",
      mobileToken: "მობაილ თოქენი",
      e_digipass: "ელ.დიგიპასი",
      digipass: "დიგიპასი",
      smsEmaill: "სმს/ელ. ფოსტა",
      kycBasicQuestions: "ძირითადი კითხვები",
      kycAdditionalQuestions: "დამატებითი კითხვები",
      dualCitizenship2: "მეორე მოქალაქეობა",
      dualCitizenshipCountry: "მეორე მოქალაქეობის ქვეყანა:",
      indicateDualCitizenshipCountry:
        "გთხოვთ მიუთითეთ მეორე მოქალაქეობის ქვეყანა",
      infoCounterparties: "ინფორმაცია კონტრაგენტებზე",
      otherAssets:
        "სხვა მნიშვნელოვანი აქტივები (მათ შორის კონვერტირებადი ვირტუალური აქტივი)",
      fieldsOfTheQuestionarieL: "გთხოვთ,  შეავსოთ კითხვარის ყველა ველი",
      appropriateColumn:
        "თითოეულ შეკითხვაზე შესაძლებელია რამოდენიმე პასუხის მონიშვნა",
      assetsInAnnex:
        "ბანკის მოთხოვნის შემთხვევაში, ქონების/თანხის წარმომავლობის დამადასტურებელი შესაბამისი დოკუმენტაცია იხილეთ დანართში",
      annex: "დანართი",
      annexDescription1: "პოლიტიკურად აქტიური პირი",
      annexDescription2:
        "- მნიშვნელოვანი საჯარო ან პოლიტიკური ფუნქციების შემსრულებელი ფიზიკური პირი (გარდა საშუალო და დაბალი რანგის თანამდებობის პირებისა), მათ შორის : სახელმწიფოს მეთაური, მთავრობის ხელმძღვანელი, მთავრობის წევრი (მინისტრი), მისი მოადგილე, სამთავრობო დაწესებულების ხელმძღვანელი; საკანონმდებლო ორგანოს (პარლამენტის) წევრი; პოლიტიკური გაერთიანების ხელმძღვანელი, მმართველი ორგანოს წევრი; უზენაესი სასამართლოს, საკონსტუტიციო სასამართლოს, უმაღლესი ინსტანციის სხვა სასამართლო ორგანოს წევრი, რომლის გადაწყვეტილებები გამონაკლის შემთხვევაში საჩივრდება; გენერალური აუდიტორი, მისი მოადგილე, აუდიტორთა სასამართლოს წევრი; ეროვნული (ცენტრალური) ბანკის საბჭოს წევრი; ელჩი, დიპლომატიური წარმომადგენლობის ხელმძღვანელი; თავდაცვის (სამხედრო) ძალების ხელმძღვანელი თანამდებობის პირი; სახელმწიფოს წილობრივი მონაწილეობით მოქმედი საწარმოს ხელმძღვანელი, მმართველობის ორგანოს წევრი; საერთაშორისო ორგანიზაციის ხელმძღვანელი, მისი მოადგილე მმართველობის ორგანოს წევრი. ასევე, პოლიტიკურად აქტიური პირის კატეგორიას მიეკუთვნებიან მათი ოჯახის წევრები: მეუღლე, და, ძმა, მშობელი, შვილი/გერი და მისი მეუღლე;",
      annexDescription3:
        "გარდა ამისა, პოლიტიკურად აქტიური პირების კატეგორიაში შედის: ფიზიკური პირი, რომელიც პოლიტიკურად აქტიურ პირთან ერთად არის იურიდიული პირის, არარეგისტრირებული ორგანიზაციული წარმონაქმნის ან ტრასტის ან ტრასტის მსგავსი სამართლებრივი სტრუქტურის ბენეფიციარი მესაკუთრე ან რომელსაც მასთან სხვაგვარი მჭიდრო საქმიანი ურთიერთობა აქვს; ასევე, ფიზიკური პირი, რომლიც არის ფაქტობრივად (არაფორმალურად) პოლიტიკურად აქტიური პირის სასარგებლოდ შექმნილი იურიდიული პირის, არარეგისტრირებული ორგანიზაციული წარმონაქმნის ან ტრასტის ან ტრასტის მსგავსი სამართლებრივი სტრუქტურის ბენეფიციარი მესაკუთრე.",
      annexDescription4:
        " გარდა ამისა, პოლიტიკურად აქტიური პირების კატეგორიაში შედის: ფიზიკური პირი, რომელიც პოლიტიკურად აქტიურ პირთან ერთად არის იურიდიული პირის, არარეგისტრირებული ორგანიზაციული წარმონაქმნის ან ტრასტის ან ტრასტის მსგავსი სამართლებრივი სტრუქტურის ბენეფიციარი მესაკუთრე ან რომელსაც მასთან სხვაგვარი მჭიდრო საქმიანი ურთიერთობა აქვს; ასევე, ფიზიკური პირი, რომლიც არის ფაქტობრივად (არაფორმალურად) პოლიტიკურად აქტიური პირის სასარგებლოდ შექმნილი იურიდიული პირის, არარეგისტრირებული ორგანიზაციული წარმონაქმნის ან ტრასტის ან ტრასტის მსგავსი სამართლებრივი სტრუქტურის ბენეფიციარი მესაკუთრე.",
      descriptionOfSource: "ქონების / ფულადი სახსრების წყაროს აღწერა",
      relevantDocument:
        "შესაბამისი დოკუმენტები (ბანკის მიერ მოთხოვნის შემთხვევაში)",
      salaryBonus: "ხელფასი / ბონუსი",
      dividend: "დივიდენდი",
      saleOfRealEstate: "უძრავ-მოძრავი ქონების გაყიდვა",
      inheritance: "მემკვიდრეობა",
      financialSupport: "ოჯახის წევრებისაგან მიღებული დახმარება",
      receivingsFromRent: "საიჯარო შემოსავლები",
      saleOfShares: "აქციების/ფასიანი ქაღალდების გაყიდვა",
      businnessActivity: "სამეწარმეო საქმიანობიდან მიღებული მოგება",
      compensation: "კომპენსაცია",
      cryptocurrency: "კრიპტოვალუტა",
      otherIncome: "სხვა შემოსავლები",
      certificate: "ცნობა დამსაქმებელი კომპანიიდან",
      bankAccountSalary: "საბანკო ამონაწერი სახელფასო ანგარიშიდან",
      bankAccount: "საბანკო ამონაწერი",
      certificateOnIssuing: "ცნობა დივიდენდის გაცემის შესახებ",
      auditCompany: "აუდიტორული კომპანიის დასკვნა",
      salesAgreement: "ნასყიდობის ხელშეკრულება",
      inheritanceCertificate: "სამკვიდრო მოწმობა/ანდერძი (ასლი)",
      courtsDecisionCopy: "სასამართლო გადაწყვეტილება (ასლი)",
      bankAccountStatement:
        "საბანკო ამონაწერი სადაც ფიქსირდება თანხის მიღება ოჯახის წევრისაგან.",
      otherOfficialDocument:
        "სხვა ოფიციალური დოკუმენტი რომელიც ადასტურებს ოჯახის წევრის/წევრების შემოსავლებს.",
      rentAgreement: "იჯარის ხელშეკრულება",
      investmentCertificate: "საინვესტიციო სერთიფიკატი ან ხელშეკრულება",
      confirmationInvestment:
        "საინვესტიციო ან საბროკერო კომპანიის წერილობითი დასტური.",
      businessActivityConfirmation: "საქმიანობის დამადასტურებელი დოკუმენტი",
      latestFinancial: "უახლესი ფინანსური ანგარიშგება",
      courtsDecision: "სასამართლო გადაწყვეტილება",
      screenshot: "ელექტრონული საფულის ან ბირჟაზე პირადი გვერდის სქრინშოტი",
      relevantOfficial: "შესაბამისი დამადასტურებელი დოკუმენტი",
      company_name: "კლიენტის დასახელება",
      registration_date: "რეგისტრაციის თარიღი",
      registration_country: "რეგისტრაციის ქვეყანა",
      company_legal_address: "კომპანიის იურიდიული მისამართი",
      company_address: "კომპანიის იურიდიული მისამართი",
      company_actual_address:
        "ბიზნეს საქმიანობის განხორციელების ფაქტიური მისამართი",
      company_web_site: "კომპანიის ვებ-გვერდი",
      business_activity_details:
        "ბიზნეს საქმიანობის დეტალური აღწერა (მაგ. ორგანიზაციის ოპერირების ბიზნეს სექტორი, საქმიანობის სახე და სფერო,  საქონლის/მომსახურების აღწერა და ა.შ)",
      owner_name: "სახელი და გვარი",
      beneficialOwner: "ბენეფიციარი მესაკუთრე",
      addBeneficialOwner: "ბენეფიციარის დამატება",

      owner_personal_id_number: "პირადი ნომერი",
      business_activity_in_georgia:
        "ეწევით თუ არა ბიზნეს საქმიანობას საქართველოს ტერიტორიაზე?",
      business_activity_in_georgia_additional:
        "გთხოვთ, მოგვაწოდოთ ინფორმაცია, როგორ არის კომპანიის საქმინობა დაკავშირებული საქართველოსთან და რა არის საქართველოში საბანკო ანგარიშის გახნის მიზანი?",

      company_connection_to_georgia:
        "კომპანიის საქმიანობის კავშირი საქართველოსთან",
      company_export_connections:
        "კომპანიის საქმიანობა დაკავშირებულია ექსპორტ/იმპორტთან? ",
      company_export_connections_additional:
        "გთხოვთ მიუთითოთ საქონლის ტრანსპორტირების მარშრუტი, საქონლის წარმოშობის/მიწოდების ქვეყანა და საქართველოს როლი.",

      estimated_money_turnover:
        "მოსალოდნელი  ჯამური თვიური ბრუნვა  ანგარიშებზე (ლარებში);",
      turnover_description_legal:
        " (ბრუნვა გულისხმობს დებეტური და კრედიტული ბრუნვების ჯამს)",
      estimated_cash_turnover:
        "მოსალოდნელი  ნაღდი ფულის თვიური ბრუნვა  ანგარიშებზე (ლარებში)",
      counterparties_description: "ინფორმაცია კონტრაგენტზე",
      estimated_cash_turnoverInfo:
        "ბრუნვა გულისხმობს  ნაღდი ფულის დებეტური და კრედიტული ბრუნვების ჯამს",
      counterparties_descriptionInfo:
        "მაგ: დასახელება,  ქვეყანა, ბიზნეს საქმიანობა; მოთხოვნის შემთხვევაში კლიენტმა უნდა წარმოადგინოს კონტრაგენტებთან გაფორმებული ორმხრივად ხელმოწერილი ხელშეკრულება",
      company_banks:
        "ბანკების დასახელება, სადაც კომპანია ფლობს/ ფლობდა საბანკო ანგარიშებს",
      owner_sources_of_founds:
        "ბენეფიციარი მესაკუთრის ფულადი სახსრების წარმომავლობის წყარო",
      owner_sources_of_founds_descriptionInfo:
        "ინფორმაცია იმ ფულადი სახსრების წამომავლობის შესახებ, რომელიც მიმდინარე ბიზნეს აქტივობას არ უკავშრდება",
      owner_assets_sources:
        "ბენეფიციარი მესაკუთრის ქონების (გარდა ფულადი სახსრებისა) წარმომავლობის წყარო.(ბანკის მოთხოვნის შემთხვევაში აუცილებელია დანართით გათვალისწინებული დოკუმენტაციის წარმოდგენა)",
      income_from_other_business_activity:
        "სხვა ბიზნეს საქმიანობიდან მიღებული შემოსავლები (გთხოვთ, მიუთითოთ დასახელება)",
      other_business_activity: "სხვა (გთხოვთ დააკონკრეტეთ)",
      invested_founds_sources:
        "კომპანიის საწყის კაპიტალში ინვესტირებული ფულადი სახსრების წარმომავლობის წყარო",
      bank_money_sources:
        "კომპანიის საბანკო ანგარიშზე განთავსებული ფულადი სახსრების წარმომავლობის წყარო",
      owner_wealth_sources:
        "ბენეფიციარი მესაკუთრის ქონება  (გარდა ფულადი სახსრებისა)",
      other_owner_wealth_sources:
        "ქონების წარმომავლობის სხვა წყარო (გთხოვთ, დააკონკრეტოთ)",
      products_and_cervices_you_use:
        "რომელი სერვისებით/პროდუქტებით ისარგებლებთ?",
      enter_valid_email: "გთხოვთ, შეიყვანოთ სწორი ელ.ფოსტა",
      table_company_money_sources: "კომპანიის ფულადი სახსრების წყარო",
      table_relevant_documents:
        "შესაბამისი დოკუმენტები (ბანკის მიერ მოთხოვნის შემთხვევაში)",
      table_founders_savings: "დამფუძნებლის დანაზოგი",
      table_bank_account_statement: "ამონაწერი საბანკო ანგარიშიდან",
      table_document_verifying_income:
        "დანაზოგისთვის საჭირო შემოსავლების დამადასტურებელი შესაბამისი ოფიციალური დოკუმენტი",
      table_founders_investments: "დამფუძნებლის ინვესტიციები",
      table_document_verifying_investment:
        "საბუთი შესრულებული შენატანის შესახებ",
      table_income_from_business_activity: "შემოსავლები ბიზნეს საქმიანობიდან",
      table_relevant_financial_declarations:
        "შესაბამისი ფინანსური ანგარიშგება/დეკლარაციები",
      table_audit_report_to_financial_situation:
        "აუდიტის მიერ მომზადებული დასკვნა კომპანიის ფინანსური მდგომარეობის შესახებ.",
      table_loan: "სესხი",
      table_loan_agreement: "სასესხო ხელშეკრულება",
      table_grants: "გრანტები",
      table_grants_agreements: "საგრანტო ხელშეკრულება",
      table_donations_charities: "შემოწირულობები/ქველმოქმედება",
      table_funding_from_budget: "საბიუჯეტო დაფინანსება",
      table_relevant_contract: "შესაბამისი შეთანხმება/ხელშეკრულება",
      table_source_of_founds_wealth_beneficial:
        "ბენეფიციარი მესაკუთრის ქონების/ფულადი სახსრების წყარო",
      table_Income_from_business_activities:
        "შემოსავლები ბიზნეს-საქმიანობიდან (დივიდენდი/ხელფასი)",
      table_certificate_dividend_salary_exit:
        "ცნობა ხელფასის/დივიდენდის გამცემი კომპანიიდან",
      table_bank_statement_where_salary_dividends_credited:
        "საბანკო ამონაწერი ანგარიშიდან სადაც ხდება ხელფასის/დივიდენდის ჩარიცხვა.",
      table_sales_in_year: "წილის გაყიდვა",
      table_shares_sales_agreement: "წილის ნასყიდობის ხელშეკრულება",
      table_OtherDocument_to_confirm_family_member_founds:
        "სხვა დოკუმენტი რომელიც ადასტურებს ოჯახის წევრის/წევრების შემოსავლებს.",
      table_owner_beneficial:
        " – ფიზიკური პირი, რომელიც არის კლიენტის საბოლოო მფლობელი ან საბოლოო მაკონტროლებელი ან/და რომლის სახელითაც მზადდება, იდება ან სრულდება გარიგება. (ოპერაცია); იურიდიული პირის ბენეფიციარი მესაკუთრეა ფიზიკური პირი, რომელიც პირდაპირ ან არაპირდაპირ ფლობს ამ იურიდიული პირის წილის ან ხმის უფლების მქონე აქციების 25 პროცენტს ან 25 პროცენტზე მეტს ან სხვაგვარად ახორციელებს იურიდიულ პირზე საბოლოო კონტროლს.",
      table_owner_beneficial_title: "ბენეფიციარი მესაკუთრე",
      kycFormTitle: "აირჩიეთ „იცნობდე შენს კლიენტს“ (KYC) კითხვარის ფორმა ",
      is_exp_imp_company:
        "არის თუ არა კომ კომპანიის საქმიანობა დაკავშირებულია ექსპორტ/იმპორტთან?",
      company_name_desc:
        "(გთხოვთ, მიუთითოთ ორგანიზაციის დასახელება და  აღწეროთ  საქმინობის სფერო და საგანი)",
      Entrepreneur: "(გთხოვთ, დეტალურად აღწეროთ საქმინობის სფერო და საგანი)",
      please_indicate_countries_related_to_transfers:
        "ანგარიშსწორების ქვეყნები",
      legal_pep_question:
        "ბენეფიციარი მესაკუთრე/ბენეფიციარი მესაკუთრის ოჯახის წევრი პოლიტიკურად აქტიური პირია?",
      mobilenumberChange: "ნომრის დამატება/შეცვლა",
      emailChange: "ელ ფოსტის დამატება/შეცვლა",
      cancelMobileNumber: "ნომრის გაუქმება ",
      cancelEmail: "ელ ფოსტის გაუქმება",
      blockedError: "თქვენ დაიბლოკეთ 24 სთ-ით. გთხოვთ, სცადოთ მოგვიანებით.",
      hasAlreadyAccountsError:
        "თქვენ გახსნილი გაქვთ ანგარიშები, ინფორმაციისათვის გთხოვთ დაუკავშირდეთ ბანკს",
      conditions: "პირობები",
      aboutTheOrganization: "ორგანიზაციის შესახებ",
      authorizedPerson: "უფლებამოსილი პირი",
      aboutServices: "სერვისების შესახებ",
      monthly_turnovers_legal:
        "ბანკში მოსალოდნელი ბრუნვების ოდენობა თვეში (ლარში)",
      monthly_cash_turnovers_legal:
        "ბანკში მოსალოდნელი ნაღდი ბრუნვების ოდენობა თვეში (ლარში)",
      Number_of_employees: "თანამშრომელთა რაოდენობა",
      write_number_of_employees: "ჩაწერეთ თანამშრომელთა რაოდენობა",
      condition1: "ორგანიზაცია რეგისტრირებულია საქართველოში.",
      condition2:
        "დირექტორი (წარმომადგენელი), რომელიც ხსნის ანგარიშს არის საქართველოს მოქალაქე ან აქვს მუდმივი ბინადრობის ნებართვა და უფლება აქვს დამოუკიდებლად წარმოადგინოს ორგანიზაცია.",
      condition3:
        " ორგანიზაციის ყველა სხვა დირექტორი (წარმომადგენელი) არის საქართველოს ან",
      condition3ending: "მოქალაქე ან აქვს მუდმივი ბინადრობის ნებართვა.",
      condition4:
        " ორგანიზაციის მფლობელი ყველა იურიდიული პირი დაფუძნებულია საქართველოში ან ",
      condition5:
        "ორგანიზაციის ყველა საბოლოო ბენეფიციარი მესაკუთრე არის საქართველოს მოქალაქე ან ",
      condition6:
        "ანგარიშის გახსნა შესაძლებელია, თუ ყველა ბენეფიციარი არის საქართველოში მუდმივი ბინადრობის ნებართვის მქონე პირი და ამავდროულად არის ",
      condition7:
        "ორგანიზაციის საქმიანობის სფერო არ არის  დაკავშირებული კრიპტო აქტივებთან, ფორექსთან ან თავისუფალ ინდუსტრიულ ზონებთან.",
      checkDocuments: "გთხოვთ, გაეცნოთ ანგარიშის გახსნისთვის საჭირო",
      checkDocuments2: "",
      documents: "დოკუმენტებს. ",
      crsFormLink: "იხილეთ ინფორმაცია CRS  თვითდეკლარაციის შესახებ",
      listedCountries: " მოცემულ  ქვეყნებში.",
      listedCountry: " მოცემული ქვეყნების",
      listedCountryWithoutDot: " მოცემული ქვეყნების",
      citizens: " მოქალაქე.",
      listOfCountries: "ქვეყნების სია",
      accountOpening:
        " თუ აკმაყოფილებთ ზემოთ ჩამოთვლილ პირობებს, განაგრძეთ ანგარიშის გახსნის პროცესი",
      countryOfIncorporation: "ორგანიზაციის რეგისტრაციის ქვეყანა",
      georgianLetters: "დასახელება ქართული ასოებით",
      name_of_company: "კომპანიის დასახელება",
      latinLetters: "დასახელება ლათინური ასოებით",
      allowed: "დასაშვებია მაქსიმუმ 26 სიმბოლო ",
      allowed2: "დასაშვები სიმბოლოებია : [A-Z],[0-9],[-/,’&.],[ space]",
      openAccount1: "ანგარიშის გახსნისთვის გთხოვთ,  შეავსოთ",
      openAccount2: "ან ეწვიოთ ფილიალს",
      appliaction: "განაცხადი",
      search: "ძებნა",
      taxation_under_FATCA:
        "არის თუ არა ორგანიზაცია FATCA-ს შესაბამისად დაბეგვრის სუბიექტი?",
      politically_exposed_person: "არის თუ არა პოლიტიკურად აქტიური პირი?",
      director_pep: "ერთ-ერთი დირექტორი",
      beneficial_owners_PEP: "ერთ-ერთი ბენეფიციარი მესაკუთრე",
      legal_economic_activity:
        "ეკონომიკური საქმიანობის სფერო (მონიშნეთ ყველა სფერო, რომლითაც  საქმიანობთ)",
      additional_information:
        "ეკონომიკურ საქმიანობასთან დაკავშირებული დამატებითი ინფორმაცია ",
      service_packages: "მომსახურების პაკეტი",
      service_full_packages: "მომსახურების სრული პაკეტი",
      legal_purpose_placeholder: "ანგარიშის გახსნის მიზანი",
      main_economic_activity: "ძირითადი ეკონომიკური საქმიანობა",
      company_registration_date: "რეგისტრაციის თარიღი",
      company_juridical_address: "კომპანიის იურიდიული მისამართი",
      company_web_page: "კომპანიის ვებ-გვერდი",
      requireCheckPep: "გთხოვთ გადაამოწმოთ ბენეფიციარი მესაკუთრის პეპ სტატუსი.",
      add: "დამატება",
      delete: "წაშლა",
      purposeOfTheIdentification: "მიუთითეთ იდენტიფიკაციის შესრულების მიზანი:",
      allowed_characters_is_4000:
        "დასაშვები სიმბოლოების მაქსიმალური რაოდენობაა 4000",
      consent_mark_purpose_header:
        "თანხმობა მარკეტინგული მიზნებისათვის მონაცემების დამუშავების თაობაზე",
      consent_data_verification_header:
        "თანხმობა საკრედიტო საინფორმაციო ბიუროს ბაზაში მონაცემების გადამოწმების შესახებ",
      consent_data_verification_lepl_header:
        "თანხმობა სსიპ შემოსავლების სამსახურის ბაზაში მონაცემების გადამოწმების შესახებ",
      issuer_information: "განაცემთა ინფორმაცია",

      MyProfile_UpdateData_Kyc_AdditionalInformation: "დამატებითი ინფორმაცია",
      MyProfile_UpdateData_Kyc_Legal_UltimateBeneficial:
        "ბენეფიციარი მესაკუთრე",
      MyProfile_UpdateDat_Kyc_Legal_UltimateBeneficialAdditionInfoPartOne:
        " - ფიზიკური პირი, რომელიც არის კლიენტის საბოლოო მფლობელი ან საბოლოო მაკონტროლებელი ან/და რომლის სახელითაც მზადდება, იდება ან სრულდება გარიგება (ოპერაცია);",
      MyProfile_UpdateDat_Kyc_Legal_UltimateBeneficialAdditionInfoPartTwo:
        "იურიდიული პირის ბენეფიციარი მესაკუთრეა ფიზიკური პირი, რომელიც პირდაპირ ან არაპირდაპირ ფლობს ამ იურიდიული პირის წილის ან ხმის უფლების მქონე აქციების 25% ან 25% - ზე მეტს ან სხვაგვარად ახორციელებს იურიდიულ პირზე საბოლოო კონტროლს.",
      MyProfile_UpdateData_Kyc_Legal_PoliticallyExposedPerson:
        "პოლიტიკურად აქტიური პირი",
      additionalInfo_Text_PEP_Info1:
        " - მნიშვნელოვანი საჯარო ან პოლიტიკური ფუნქციების შემსრულებელი ფიზიკური პირი (გარდა საშუალო და დაბალი რანგის თანამდებობის პირებისა), მათ შორის: სახელმწიფოს მეთაური, მთავრობის ხელმძღვანელი, მთავრობის წევრი (მინისტრი), მისი მოადგილე, სამთავრობო დაწესებულების ხელმძღვანელი; საკანონმდებლო ორგანოს (პარლამენტის) წევრი; პოლიტიკური გაერთიანების ხელმძღვანელი, მმართველი ორგანოს წევრი; უზენაესი სასამართლოს, საკონსტუტიციო სასამართლოს, უმაღლესი ინსტანციის სხვა სასამართლო ორგანოს წევრი, რომლის გადაწყვეტილებები გამონაკლის შემთხვევაში საჩივრდება; გენერალური აუდიტორი, მისი მოადგილე, აუდიტორთა სასამართლოს წევრი; ეროვნული (ცენტრალური) ბანკის საბჭოს წევრი; ელჩი, დიპლომატიური წარმომადგენლობის ხელმძღვანელი; თავდაცვის (სამხედრო) ძალების ხელმძღვანელი თანამდებობის პირი; სახელმწიფოს წილობრივი მონაწილეობით მოქმედი საწარმოს ხელმძღვანელი, მმართველობის ორგანოს წევრი; საერთაშორისო ორგანიზაციის ხელმძღვანელი, მისი მოადგილე მმართველობის ორგანოს წევრი. ასევე, პოლიტიკურად აქტიური პირის კატეგორიას მიეკუთვნებიან მათი ოჯახის წევრები: მეუღლე/პირი, რომელთანაც პოლიტიკურად აქტიური პირი მუდმივად ეწევა ერთიან საოჯახო მეურნეობას, და, ძმა, მშობელი, შვილი/გერი და მისი მეუღლე/პირი რომელთანაც ის მუდმივად ეწევა ერთიან საოჯახო მეურნეობას.",
      additionalInfo_Text_PEP_Info2:
        "გარდა ამისა, პოლიტიკურად აქტიური პირების კატეგორიაში შედის: ფიზიკური პირი, რომელიც პოლიტიკურად აქტიურ პირთან ერთად არის იურიდიული პირის, არარეგისტრირებული ორგანიზაციული წარმონაქმნის ან ტრასტის, ან ტრასტის მსგავსი სამართლებრივი სტრუქტურის ბენეფიციარი მესაკუთრე ან რომელსაც მასთან სხვაგვარი მჭიდრო საქმიანი, სოციალური ან პოლიტიკური ურთიერთობა აქვს; ასევე, ფიზიკური პირი, რომლიც არის ფაქტობრივად (არაფორმალურად) პოლიტიკურად აქტიური პირის სასარგებლოდ შექმნილი იურიდიული პირის, არარეგისტრირებული ორგანიზაციული წარმონაქმნის ან ტრასტის, ან ტრასტის მსგავსი სამართლებრივი სტრუქტურის ბენეფიციარი მესაკუთრე.",
      Source_of_funds: "კომპანიის ფულადი სახსრების წყარო",
      Source_of_wealth: "ბენეფიციარი მესაკუთრის ქონების/ფულადი სახსრების წყარო",
      consent_data_income_remittance_header:
        "თანხმობა გზავნილებით მიღებული შემოსავლების დამუშავებაზე",
      read_more: "სრულად წაკითხვა",
      hide: "დამალვა",

      ...TRANSLATION_KA,
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    whitelist: ["ka", "en"],
    resources,
    ns: ["translation"],
    defaultNS: "translation",

    lng: languageLoader(), // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    keySeparator: false, // we do not use keys in form messages.welcome3
  });

export default i18n;
